import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { reduxForm } from 'redux-form';
import { propChildren, propStr, ReduxFormProps, } from '../../../helpers/custom-prop-types';
import FormRegistrationInnerLayoutNew from './FormRegistrationInnerLayoutNew';
const FormRegistrationInner = (props) => {
    const { error, handleSubmit, newHeaderDescription, newHeaderTitle, requestDivisionLabelName, submitting, } = props;
    return (_jsx(FormRegistrationInnerLayoutNew, { error: error, handleSubmit: handleSubmit, headerDescription: newHeaderDescription, headerTitle: newHeaderTitle, requestDivisionLabelName: requestDivisionLabelName, submitting: submitting }));
};
FormRegistrationInner.propTypes = Object.assign({ newHeaderDescription: propChildren(), newHeaderTitle: propChildren(), requestDivisionLabelName: propStr().isRequired }, ReduxFormProps);
FormRegistrationInner.defaultProps = {
    newHeaderDescription: undefined,
    newHeaderTitle: undefined,
};
export default reduxForm({ form: 'FormRegistration' })(FormRegistrationInner);
